import { Grid } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { LocalizedDateFromUtc, SpacedDash, Dash } from '@mews-commander/ui';
import { LocalizedCurrency, lt } from '@mews/framework';
import { ReservationLinkResult } from '@mews-commander/data-access';
import { PaymentPlanDetailItem } from '../../views/PaymentPlanDetails/PaymentPlanDetailItem';
import { useGetPaymentPlanLocalizedDates, useGetAmountsForPaymentPlanSuspense } from './hooks';
import { CreatePaymentPlanDetailCard } from './CreatePaymentPlanDetailCard';
import { getDefaultAmount } from './utils';

export const FirstPaymentDetails = ({ reservation }: { reservation: ReservationLinkResult }) => {
    const { reservationStartUtc, reservationEndUtc } = reservation;
    const { planStartDate, planEndDate } = useGetPaymentPlanLocalizedDates(reservation);
    const { monthlyAmounts, averageMonthlyRate } = useGetAmountsForPaymentPlanSuspense(reservation);
    const planCurrency = getDefaultAmount(monthlyAmounts[0].amount).currency;
    return (
        <CreatePaymentPlanDetailCard
            title="CreatePaymentPlanFirstPaymentDetailsLabelDetails"
            variant="subtle"
            outline={false}
        >
            <Grid templateColumns="auto 1fr" columnGap="500" rowGap="200">
                <PaymentPlanDetailItem
                    description={TextKey.CreatePaymentPlanFirstPaymentDetailsLabelPaymentExecutionDay}
                    value={lt(TextKey.CreatePaymentPlanFirstPaymentDetailsValueFirstOfTheMonth)}
                />
                <PaymentPlanDetailItem
                    description={TextKey.CreatePaymentPlanFirstPaymentDetailsLabelPlanDates}
                    value={`${planStartDate}${SpacedDash}${planEndDate}`}
                />
                <PaymentPlanDetailItem
                    description={TextKey.CreatePaymentPlanFirstPaymentDetailsLabelReservationDates}
                    value={
                        <>
                            <LocalizedDateFromUtc utcString={reservationStartUtc} />
                            {SpacedDash}
                            <LocalizedDateFromUtc utcString={reservationEndUtc} />
                        </>
                    }
                />
                <PaymentPlanDetailItem
                    description={TextKey.CreatePaymentPlanFirstPaymentDetailsLabelMonthRate}
                    value={
                        averageMonthlyRate ? (
                            <LocalizedCurrency value={averageMonthlyRate.value} currency={planCurrency} />
                        ) : (
                            <Dash />
                        )
                    }
                />
            </Grid>
        </CreatePaymentPlanDetailCard>
    );
};
